import { viewport } from '../utils/viewport.js';
import $ from 'jquery';

const selectors = {
  navbar: '.js-navbar',
  mobileMenu: '.js-navbar-mobile'
}

export default class Navbar {
  constructor() {
    const element = $(selectors.navbar);
    this.isOpenMain = false;
    this.isOpenMeta = false;

    // Bind events
    $(window).scroll(() => this.onScroll(element));
    $(window).resize(() => this.onResize(element));

    $(selectors.mobileMenu).on('show.bs.collapse', (e) => this.onShowMobileMenu(e));
    $(selectors.mobileMenu).on('hide.bs.collapse', (e) => this.onHideMobileMenu(e));

    // Fire onscroll on init
    this.onScroll(element);
  }

  onShowMobileMenu(e) {
    if ($(e.target).hasClass('js-mobile-main')) {
      this.isOpenMain = true;
    } else if ($(e.target).hasClass('js-mobile-meta')) {
      this.isOpenMeta = true;
    }

    this.preventBodyScroll();
  }

  onHideMobileMenu(e) {
    if ($(e.target).hasClass('js-mobile-main')) {
      this.isOpenMain = false;
    } else if ($(e.target).hasClass('js-mobile-meta')) {
      this.isOpenMeta = false;
    }

    const openDropdowns = $(e.target).find('.collapse.show');
    this.collapseSubmenu(openDropdowns);
    if (this.isOpenMain === false && this.isOpenMeta === false) {
      this.allowBodyScroll();
    }
  }

  preventBodyScroll() {
    $('body').addClass('u-prevent-scroll');
  }

  allowBodyScroll() {
    $('body').removeClass('u-prevent-scroll');
  }

  collapseSubmenu(openDropdowns) {
    // close the menu and reset the css.
    openDropdowns.each(function () {
      $(this).removeClass('show');
      $(this).siblings().attr('aria-expanded', false);
    })
  }

  /*
  * onScroll
  * User scrolls on page
  */
  onScroll(element) {
    this.positionMeta(element);
  }

  /*
  * onScroll
  * User scrolls on page
  */
  onResize(element) {
    this.positionMeta(element);
    if (viewport.isEqualOrGreaterThan('md')) {
      const openDropdowns = $(element).find('.collapse.show');
      this.collapseSubmenu(openDropdowns);
      this.closeMenu();
      this.allowBodyScroll();
    }
  }

  closeMenu() {
    $('.navbar-toggler').each(function (element) {
      $(this).attr('aria-expanded', false).addClass('collapsed');
    })
  }

  positionMeta(element) {
    if ($(window).scrollTop() > 30 || viewport.isEqualOrSmallerThan('md')) {
      element.addClass("fixed-top");
    } else {
      element.removeClass("fixed-top");
    }
  }
}

/*
 * Create a new Navbar() instance
 */
new Navbar();
